import * as HYPERCUBEJS from '@hypercubejs/hypercubejs';

/**
 * Creates 16x16 plane gameobjects.
 * @param {HYPERCUBEJS.Material} [$material] The material to add.
 * @returns {HYPERCUBEJS.Node}
 */
function gameobjectplane16x16($material = HYPERCUBEJS.DEFAULTS.material()) {

    const plane16x16 = new HYPERCUBEJS.Node('plane16x16');
    const meshplane16x16 = new HYPERCUBEJS.MeshPlane('meshplane16x16', [16, 16]);

    meshplane16x16.setmaterial($material);
    plane16x16.addmesh(meshplane16x16);

    plane16x16.setcomponent('collideraabb', {

        'type': 'static',

        'min': [-8, 0, -8],
        'max': [8, 0, 8]
    });

    return plane16x16;
}

export {

    gameobjectplane16x16
};

export default gameobjectplane16x16;
